import { AppStateAction, AppStateActions } from '@/reducers/appReducer';
import { Dispatch } from 'react';

export const pushNotificationMessage = (
  dispatch: Dispatch<AppStateAction>,
  message: string,
  type: 'info' | 'error' | 'success' = 'info',
  timeout: number | null = null,
) => {
  let timeoutId: number | undefined;

  if (timeout) {
    timeoutId = window.setTimeout(() => {
      dispatch({
        type: AppStateActions.SET_NOTIFICATION_TEXT,
        payload: {
          message: '',
        },
      });
    }, timeout);
  }

  dispatch({
    type: AppStateActions.SET_NOTIFICATION_TEXT,
    payload: {
      message,
      type,
      timeoutId,
    },
  });
};
